<template>
  <div class="room gas-clamp">
    <RefreshBlock @refreshData="refreshData"></RefreshBlock>
    <div class="main-cable" v-loading="loading">
      <div class="cable-title">
        <h2>北航道南塔</h2>
      </div>
      <div class="cable-main">
        <div class="legend">
          <div class="sensor1">传感器组</div>
        </div>
        <div class="legend-station">
          <i class="iconfont iconshebei"></i>
          <span>除湿机</span>
        </div>
        <div class="legend-right">
          <div class="running">设备运行</div>
          <div class="stopped">设备停止</div>
          <div class="default">数据中断</div>
        </div>
        <div class="dir left-dir">
          <i class="iconfont icongeo-arrow-left"></i>
          <span class="dir-text">嘉兴</span>
        </div>
        <div class="dir right-dir">
          <i class="iconfont icongeo-arrow-left-copy"></i>
          <span class="dir-text">宁波</span>
        </div>
        <div class="cable-img">
          <el-tooltip class="station-block station-block-tower" content="NT2#除湿机" effect="light" placement="top">
            <router-link class="iconfont iconshebei" to="/hangzhouwan/tower/northChannelSouthTower"></router-link>
          </el-tooltip>
          <div class="stati sta-tower">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{
                  assembleTooltip_dehumidifier(
                    "",
                    humidityTooltipErrorNT2Dehumidifier,
                    humidityAllowedMaxNT2Dehumidifier,
                    runningDehumidifierNT2,
                    malfunctionDehumidifierNT2
                  )
                }}
              </div>
              <div :class="errorNT2Dehumidifier" class="state-info right-pos">
                <p>北航道南塔除湿机</p>
                <p>
                  <span>{{ humidityNT2Dehumidifier | toFixed }}% {{ temperatureNT2Dehumidifier | toFixed }}°C</span>
                  <!-- <el-tooltip :content="runningTooltipNT2" effect="light" placement="right"> -->
                  <span :class="runningClassNT2" class="valve-sign"></span>
                  <!-- </el-tooltip> -->
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-t4">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorT4, humidityAllowedMaxT4) }}
              </div>
              <div :class="errorT4" class="state-info right-pos">
                <p>塔内温湿度4</p>
                <p>
                  <span>{{ humidityT4 | toFixed }}% {{ temperatureT4 | toFixed }}°C</span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-t3">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorT3, humidityAllowedMaxT3) }}
              </div>
              <div :class="errorT3" class="state-info left-pos">
                <p>塔内温湿度3</p>
                <p>
                  <span>{{ humidityT3 | toFixed }}% {{ temperatureT3 | toFixed }}°C</span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-t2">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorT2, humidityAllowedMaxT2) }}
              </div>
              <div :class="errorT2" class="state-info right-pos">
                <p>塔内温湿度2</p>
                <p>
                  <span>{{ humidityT2 | toFixed }}% {{ temperatureT2 | toFixed }}°C</span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-t1">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorT1, humidityAllowedMaxT1) }}
              </div>
              <div :class="errorT1" class="state-info left-pos">
                <p>塔内温湿度1</p>
                <p>
                  <span>{{ humidityT1 | toFixed }}% {{ temperatureT1 | toFixed }}°C</span>
                </p>
              </div>
            </el-tooltip>
          </div>
        </div>
      </div>
    </div>

    <div class="main-cable" v-loading="loading">
      <div class="cable-title">
        <h2>北航道南塔区钢箱梁</h2>
      </div>
      <div class="cable-main">
        <div class="legend">
          <div class="sensor1">传感器组</div>
        </div>
        <!-- <div class="legend-station">
          <i class="iconfont iconshebei"></i>
          <span>除湿机</span>
        </div> -->
        <div class="legend-right">
          <div class="running">设备运行</div>
          <div class="stopped">设备停止</div>
          <div class="default">数据中断</div>
        </div>
        <div class="dir left-dir">
          <i class="iconfont icongeo-arrow-left"></i>
          <span class="dir-text">嘉兴</span>
        </div>
        <div class="dir right-dir">
          <i class="iconfont icongeo-arrow-left-copy"></i>
          <span class="dir-text">宁波</span>
        </div>
        <div class="cable-img">
          <el-tooltip class="station-block station-block-left" content="NS3#/NS4#除湿机" effect="light" placement="top">
            <router-link class="iconfont iconshebei" to="/hangzhouwan/steelBox/ns3ns4"></router-link>
          </el-tooltip>
          <div class="stati sta-left-left">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{
                  assembleTooltip_dehumidifier(
                    "",
                    humidityTooltipErrorNS3Dehumidifier,
                    humidityAllowedMaxNS3Dehumidifier,
                    runningDehumidifierNS3,
                    malfunctionDehumidifierNS3
                  )
                }}
              </div>
              <div :class="errorNS3Dehumidifier" class="state-info right-pos">
                <p>NS3#除湿机</p>
                <p>
                  <span>{{ humidityNS3Dehumidifier | toFixed }}% {{ temperatureNS3Dehumidifier | toFixed }}°C</span>
                  <!-- <el-tooltip :content="runningTooltipNS3" effect="light" placement="right"> -->
                  <span :class="runningClassNS3" class="valve-sign"></span>
                  <!-- </el-tooltip> -->
                </p>
              </div>
            </el-tooltip>
          </div>
          <div class="stati sta-left-right">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{
                  assembleTooltip_dehumidifier(
                    "",
                    humidityTooltipErrorNS4Dehumidifier,
                    humidityAllowedMaxNS4Dehumidifier,
                    runningDehumidifierNS4,
                    malfunctionDehumidifierNS4
                  )
                }}
              </div>
              <div :class="errorNS4Dehumidifier" class="state-info left-pos">
                <p>NS4#除湿机</p>
                <p>
                  <span>{{ humidityNS4Dehumidifier | toFixed }}% {{ temperatureNS4Dehumidifier | toFixed }}°C</span>
                  <!-- <el-tooltip :content="runningTooltipNS4" effect="light" placement="right"> -->
                  <span :class="runningClassNS4" class="valve-sign"></span>
                  <!-- </el-tooltip> -->
                </p>
              </div>
            </el-tooltip>
          </div>

          <el-tooltip class="station-block station-block-right" content="NS1#/NS2#除湿机" effect="light" placement="top">
            <router-link class="iconfont iconshebei" to="/hangzhouwan/steelBox/ns1ns2"></router-link>
          </el-tooltip>
          <div class="stati sta-right-left">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{
                  assembleTooltip_dehumidifier(
                    "",
                    humidityTooltipErrorNS1Dehumidifier,
                    humidityAllowedMaxNS1Dehumidifier,
                    runningDehumidifierNS1,
                    malfunctionDehumidifierNS1
                  )
                }}
              </div>
              <div :class="errorNS1Dehumidifier" class="state-info right-pos">
                <p>NS1#除湿机</p>
                <p>
                  <span>{{ humidityNS1Dehumidifier | toFixed }}% {{ temperatureNS1Dehumidifier | toFixed }}°C</span>
                  <!-- <el-tooltip :content="runningTooltipNS1" effect="light" placement="right"> -->
                  <span :class="runningClassNS1" class="valve-sign"></span>
                  <!-- </el-tooltip> -->
                </p>
              </div>
            </el-tooltip>
          </div>
          <div class="stati sta-right-right">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{
                  assembleTooltip_dehumidifier(
                    "",
                    humidityTooltipErrorNS2Dehumidifier,
                    humidityAllowedMaxNS2Dehumidifier,
                    runningDehumidifierNS2,
                    malfunctionDehumidifierNS2
                  )
                }}
              </div>
              <div :class="errorNS2Dehumidifier" class="state-info left-pos">
                <p>NS2#除湿机</p>
                <p>
                  <span>{{ humidityNS2Dehumidifier | toFixed }}% {{ temperatureNS2Dehumidifier | toFixed }}°C</span>
                  <!-- <el-tooltip :content="runningTooltipNS2" effect="light" placement="right"> -->
                  <span :class="runningClassNS2" class="valve-sign"></span>
                  <!-- </el-tooltip> -->
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-s04">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorS04, humidityAllowedMaxS04) }}
              </div>
              <div :class="errorS04" class="state-info left-pos">
                <p>S04梁段传感器</p>
                <p>
                  <span>{{ humidityS04 | toFixed }}% {{ temperatureS04 | toFixed }}°C</span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-sb12">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorSB12, humidityAllowedMaxSB12) }}
              </div>
              <div :class="errorSB12" class="state-info left-pos">
                <p>SB12梁段传感器</p>
                <p>
                  <span>{{ humiditySB12 | toFixed }}% {{ temperatureSB12 | toFixed }}°C</span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-sb8">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorSB8, humidityAllowedMaxSB8) }}
              </div>
              <div :class="errorSB8" class="state-info left-pos">
                <p>SB8梁段传感器</p>
                <p>
                  <span>{{ humiditySB8 | toFixed }}% {{ temperatureSB8 | toFixed }}°C</span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-sb5">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorSB5, humidityAllowedMaxSB5) }}
              </div>
              <div :class="errorSB5" class="state-info left-pos">
                <p>SB5梁段传感器</p>
                <p>
                  <span>{{ humiditySB5 | toFixed }}% {{ temperatureSB5 | toFixed }}°C</span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-sb2">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorSB2, humidityAllowedMaxSB2) }}
              </div>
              <div :class="errorSB2" class="state-info left-pos">
                <p>SB2梁段传感器</p>
                <p>
                  <span>{{ humiditySB2 | toFixed }}% {{ temperatureSB2 | toFixed }}°C</span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-sz1">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorSZ1, humidityAllowedMaxSZ1) }}
              </div>
              <div :class="errorSZ1" class="state-info right-pos">
                <p>SZ1梁段传感器</p>
                <p>
                  <span>{{ humiditySZ1 | toFixed }}% {{ temperatureSZ1 | toFixed }}°C</span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-sz5">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorSZ5, humidityAllowedMaxSZ5) }}
              </div>
              <div :class="errorSZ5" class="state-info right-pos">
                <p>SZ5梁段传感器</p>
                <p>
                  <span>{{ humiditySZ5 | toFixed }}% {{ temperatureSZ5 | toFixed }}°C</span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-sz8">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorSZ8, humidityAllowedMaxSZ8) }}
              </div>
              <div :class="errorSZ8" class="state-info right-pos">
                <p>SZ8梁段传感器</p>
                <p>
                  <span>{{ humiditySZ8 | toFixed }}% {{ temperatureSZ8 | toFixed }}°C</span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-sz11">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorSZ11, humidityAllowedMaxSZ11) }}
              </div>
              <div :class="errorSZ11" class="state-info right-pos">
                <p>SZ11梁段传感器</p>
                <p>
                  <span>{{ humiditySZ11 | toFixed }}% {{ temperatureSZ11 | toFixed }}°C</span>
                </p>
              </div>
            </el-tooltip>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "gasClamp",
  data() {
    return {
      loading: true,
      timer: null,

      //humidity, temperature
      humidityNS3Dehumidifier: "--",
      humidityNS4Dehumidifier: "--",
      humidityNS1Dehumidifier: "--",
      humidityNS2Dehumidifier: "--",
      humidityNT2Dehumidifier: "--",
      temperatureNS3Dehumidifier: "--",
      temperatureNS4Dehumidifier: "--",
      temperatureNS1Dehumidifier: "--",
      temperatureNS2Dehumidifier: "--",
      temperatureNT2Dehumidifier: "--",

      humidityS04: "--",
      humiditySB12: "--",
      humiditySB8: "--",
      humiditySB5: "--",
      humiditySB2: "--",
      humiditySZ1: "--",
      humiditySZ5: "--",
      humiditySZ8: "--",
      humiditySZ11: "--",
      humidityT1: "--",
      humidityT2: "--",
      humidityT3: "--",
      humidityT4: "--",
      temperatureS04: "--",
      temperatureSB12: "--",
      temperatureSB8: "--",
      temperatureSB5: "--",
      temperatureSB2: "--",
      temperatureSZ1: "--",
      temperatureSZ5: "--",
      temperatureSZ8: "--",
      temperatureSZ11: "--",
      temperatureT1: "--",
      temperatureT2: "--",
      temperatureT3: "--",
      temperatureT4: "--",

      //humidity allowed max
      humidityAllowedMaxNS3Dehumidifier: "--",
      humidityAllowedMaxNS4Dehumidifier: "--",
      humidityAllowedMaxNS1Dehumidifier: "--",
      humidityAllowedMaxNS2Dehumidifier: "--",
      humidityAllowedMaxNT2Dehumidifier: "--",
      humidityAllowedMaxS04: "--",
      humidityAllowedMaxSB12: "--",
      humidityAllowedMaxSB8: "--",
      humidityAllowedMaxSB5: "--",
      humidityAllowedMaxSB2: "--",
      humidityAllowedMaxSZ1: "--",
      humidityAllowedMaxSZ5: "--",
      humidityAllowedMaxSZ8: "--",
      humidityAllowedMaxSZ11: "--",
      humidityAllowedMaxT1: "--",
      humidityAllowedMaxT2: "--",
      humidityAllowedMaxT3: "--",
      humidityAllowedMaxT4: "--",

      //humidity tooltip error
      humidityTooltipErrorNS3Dehumidifier: "--",
      humidityTooltipErrorNS4Dehumidifier: "--",
      humidityTooltipErrorNS1Dehumidifier: "--",
      humidityTooltipErrorNS2Dehumidifier: "--",
      humidityTooltipErrorNT2Dehumidifier: "--",
      humidityTooltipErrorS04: "--",
      humidityTooltipErrorSB12: "--",
      humidityTooltipErrorSB8: "--",
      humidityTooltipErrorSB5: "--",
      humidityTooltipErrorSB2: "--",
      humidityTooltipErrorSZ1: "--",
      humidityTooltipErrorSZ5: "--",
      humidityTooltipErrorSZ8: "--",
      humidityTooltipErrorSZ11: "--",
      humidityTooltipErrorT1: "--",
      humidityTooltipErrorT2: "--",
      humidityTooltipErrorT3: "--",
      humidityTooltipErrorT4: "--",

      //running
      runningDehumidifierNS3: "--",
      runningDehumidifierNS4: "--",
      runningDehumidifierNS1: "--",
      runningDehumidifierNS2: "--",
      runningDehumidifierNT2: "--",

      //malfunction
      malfunctionDehumidifierNS3: "--",
      malfunctionDehumidifierNS4: "--",
      malfunctionDehumidifierNS1: "--",
      malfunctionDehumidifierNS2: "--",
      malfunctionDehumidifierNT2: "--",

      //error
      errorNS3Dehumidifier: "--",
      errorNS4Dehumidifier: "--",
      errorNS1Dehumidifier: "--",
      errorNS2Dehumidifier: "--",
      errorNT2Dehumidifier: "--",

      errorS04: "--",
      errorSB12: "--",
      errorSB8: "--",
      errorSB5: "--",
      errorSB2: "--",
      errorSZ1: "--",
      errorSZ5: "--",
      errorSZ8: "--",
      errorSZ11: "--",
      errorT1: "--",
      errorT2: "--",
      errorT3: "--",
      errorT4: "--",

      // //running tooltip and class
      // runningTooltipNS3: "--",
      // runningTooltipNS4: "--",
      // runningTooltipNS1: "--",
      // runningTooltipNS2: "--",
      // runningTooltipNT2: "--",

      //running class
      runningClassNS3: "",
      runningClassNS4: "",
      runningClassNS1: "",
      runningClassNS2: "",
      runningClassNT2: "",

      //humidity, temperature, running -> id
      dataNameIdDict: {
        //humidity, temperature
        humidityNS3Dehumidifier: "724b35a2-149e-4a46-a64c-c922c5302455",
        humidityNS4Dehumidifier: "8aece8c4-b1a9-48cc-9da5-c7136db4dad5",
        humidityNS1Dehumidifier: "835fb81a-d799-4d4c-9a47-3736fd34080d",
        humidityNS2Dehumidifier: "68dc586a-3bf6-4caa-b8d3-edcc574786d8",
        humidityNT2Dehumidifier: "ff27c6d4-c6d4-46db-a91d-a4be138c7183",
        temperatureNS3Dehumidifier: "d1b22da3-313f-43c7-9eeb-441459765e10",
        temperatureNS4Dehumidifier: "228004bf-324d-495c-8b17-b4c5ea21321e",
        temperatureNS1Dehumidifier: "e8016fd9-6d9f-4d2d-9ab0-f11a0bde6374",
        temperatureNS2Dehumidifier: "32cb7bf3-811f-4a01-b97a-8e60f6fcb3d9",
        temperatureNT2Dehumidifier: "b5f8190f-0f4b-4b1b-8308-24cfd32749dc",

        humidityS04: "e1fd3b38-37d1-47e8-9e6f-5979dc1e5cab",
        humiditySB12: "988680b5-cb15-4d50-9152-d0a4d9c08348",
        humiditySB8: "34d02f8d-7eec-4916-aa29-28014d82aaea",
        humiditySB5: "94fc6ec1-31d6-46bb-ac22-843c9bda1da4",
        humiditySB2: "3de42f22-d38e-4d11-97fd-acb6759e9a7f",
        humiditySZ1: "dc2565bf-b1d1-43b8-afc6-71cc348b9f18",
        humiditySZ5: "547d364b-8f64-436e-be05-6e39ca37a090",
        humiditySZ8: "ca738dcf-b1e1-46cd-b57f-41acfdb8563c",
        humiditySZ11: "f3ce1886-1739-45c4-9503-b558baa5399d",
        humidityT1: "bddc0963-d126-4f04-91b9-58b7784019e3",
        humidityT2: "2ed3976e-381e-48e2-a197-cf4c37e81749",
        humidityT3: "7dddd449-ee09-4e2f-84e6-879a8f274d73",
        humidityT4: "c70c3db0-841d-4f68-99cc-6123e9c45093",
        temperatureS04: "c89a7c20-6334-43b3-bd14-b0a213f213b4",
        temperatureSB12: "c8e7dad1-1b64-43b0-bab9-9ed03c776499",
        temperatureSB8: "abb9d89a-2d37-4afe-9fac-d3e8041206ed",
        temperatureSB5: "ee5132f0-740e-4572-9ffe-0913ff620de3",
        temperatureSB2: "b821db79-99ff-4e03-96eb-80ea0bdd22e3",
        temperatureSZ1: "72e02db4-3827-4bdb-b8d9-af84d49ec93f",
        temperatureSZ5: "ea2428f9-0614-4094-be10-d259d392eacb",
        temperatureSZ8: "925807bf-56bb-47fc-8096-d1a168f8a948",
        temperatureSZ11: "5c041431-0e9d-4157-84c0-da202abd8aa2",
        temperatureT1: "78d604b7-1223-42f5-b8c9-4912da37c7a9",
        temperatureT2: "f3d6bed9-de2e-4060-8b2b-a5241ac0f3d3",
        temperatureT3: "f719b446-2a84-4b0c-b303-f136aa4ad790",
        temperatureT4: "b00795b5-8791-4d88-a9d3-3ec7a9f60ad2",

        //running
        runningDehumidifierNS3: "ddbb8e2c-00f8-492c-b5fa-6906b7468116",
        runningDehumidifierNS4: "68f75131-0bb8-4299-a648-049b502828ba",
        runningDehumidifierNS1: "4b96e7b3-35d7-4e89-8dd4-543329837179",
        runningDehumidifierNS2: "6ab636a7-cb0b-46f7-9840-7d6f129831bd",
        runningDehumidifierNT2: "c9facb5e-2bdb-46a5-8a2a-e4008955e3fc",

        //malfunction
        malfunctionDehumidifierNS3: "c4fabdd2-29c5-46bf-b44d-a80198e78f25",
        malfunctionDehumidifierNS4: "ec04617f-631b-4ee2-9057-121164d5cb3a",
        malfunctionDehumidifierNS1: "5d32f798-0bb3-4872-9f49-048761c3fd91",
        malfunctionDehumidifierNS2: "974d34c7-35ea-4826-8bad-f5b577a551d3",
        malfunctionDehumidifierNT2: "80838ca9-f943-427d-b73d-2ef837f099da",
      },

      //allowed max name id dict
      allowedMaxNameIdDict: {
        humidityAllowedMaxNS3Dehumidifier: "724b35a2-149e-4a46-a64c-c922c5302455",
        humidityAllowedMaxNS4Dehumidifier: "8aece8c4-b1a9-48cc-9da5-c7136db4dad5",
        humidityAllowedMaxNS1Dehumidifier: "835fb81a-d799-4d4c-9a47-3736fd34080d",
        humidityAllowedMaxNS2Dehumidifier: "68dc586a-3bf6-4caa-b8d3-edcc574786d8",
        humidityAllowedMaxNT2Dehumidifier: "ff27c6d4-c6d4-46db-a91d-a4be138c7183",
        humidityAllowedMaxS04: "e1fd3b38-37d1-47e8-9e6f-5979dc1e5cab",
        humidityAllowedMaxSB12: "988680b5-cb15-4d50-9152-d0a4d9c08348",
        humidityAllowedMaxSB8: "34d02f8d-7eec-4916-aa29-28014d82aaea",
        humidityAllowedMaxSB5: "94fc6ec1-31d6-46bb-ac22-843c9bda1da4",
        humidityAllowedMaxSB2: "3de42f22-d38e-4d11-97fd-acb6759e9a7f",
        humidityAllowedMaxSZ1: "dc2565bf-b1d1-43b8-afc6-71cc348b9f18",
        humidityAllowedMaxSZ5: "547d364b-8f64-436e-be05-6e39ca37a090",
        humidityAllowedMaxSZ8: "ca738dcf-b1e1-46cd-b57f-41acfdb8563c",
        humidityAllowedMaxSZ11: "f3ce1886-1739-45c4-9503-b558baa5399d",
        humidityAllowedMaxT1: "bddc0963-d126-4f04-91b9-58b7784019e3",
        humidityAllowedMaxT2: "2ed3976e-381e-48e2-a197-cf4c37e81749",
        humidityAllowedMaxT3: "7dddd449-ee09-4e2f-84e6-879a8f274d73",
        humidityAllowedMaxT4: "c70c3db0-841d-4f68-99cc-6123e9c45093",
      },

      //humidity, temperature -> error
      dataNameErrorNameDict: {
        //humidity, temperature
        humidityNS3Dehumidifier: "errorNS3Dehumidifier",
        humidityNS4Dehumidifier: "errorNS4Dehumidifier",
        humidityNS1Dehumidifier: "errorNS1Dehumidifier",
        humidityNS2Dehumidifier: "errorNS2Dehumidifier",
        humidityNT2Dehumidifier: "errorNT2Dehumidifier",
        temperatureNS3Dehumidifier: "errorNS3NSDehumidifier",
        temperatureNS4Dehumidifier: "errorNS4Dehumidifier",
        temperatureNS1Dehumidifier: "errorNS1Dehumidifier",
        temperatureNS2Dehumidifier: "errorNS2Dehumidifier",
        temperatureNT2Dehumidifier: "errorNT2Dehumidifier",

        humidityS04: "errorS04",
        humiditySB12: "errorSB12",
        humiditySB8: "errorSB8",
        humiditySB5: "errorSB5",
        humiditySB2: "errorSB2",
        humiditySZ1: "errorSZ1",
        humiditySZ5: "errorSZ5",
        humiditySZ8: "errorSZ8",
        humiditySZ11: "errorSZ11",
        humidityT1: "errorT1",
        humidityT2: "errorT2",
        humidityT3: "errorT3",
        humidityT4: "errorT4",
        temperatureS04: "errorS04",
        temperatureSB12: "errorSB12",
        temperatureSB8: "errorSB8",
        temperatureSB5: "errorSB5",
        temperatureSB2: "errorSB2",
        temperatureSZ1: "errorSZ1",
        temperatureSZ5: "errorSZ5",
        temperatureSZ8: "errorSZ8",
        temperatureSZ11: "errorSZ11",
        temperatureT1: "errorT1",
        temperatureT2: "errorT2",
        temperatureT3: "errorT3",
        temperatureT4: "errorT4",
      },

      malfunctionDataNameErrorNameDict: {
        malfunctionDehumidifierNS3: "errorNS3Dehumidifier",
        malfunctionDehumidifierNS4: "errorNS4Dehumidifier",
        malfunctionDehumidifierNS1: "errorNS1Dehumidifier",
        malfunctionDehumidifierNS2: "errorNS2Dehumidifier",
        malfunctionDehumidifierNT2: "errorNT2Dehumidifier",
      },

      //humidity -> humidity tooltip error
      dataNameTooltipErrorNameDict: {
        humidityNS3Dehumidifier: "humidityTooltipErrorNS3Dehumidifier",
        humidityNS4Dehumidifier: "humidityTooltipErrorNS4Dehumidifier",
        humidityNS1Dehumidifier: "humidityTooltipErrorNS1Dehumidifier",
        humidityNS2Dehumidifier: "humidityTooltipErrorNS2Dehumidifier",
        humidityNT2Dehumidifier: "humidityTooltipErrorNT2Dehumidifier",
        humidityS04: "humidityTooltipErrorS04",
        humiditySB12: "humidityTooltipErrorSB12",
        humiditySB8: "humidityTooltipErrorSB8",
        humiditySB5: "humidityTooltipErrorSB5",
        humiditySB2: "humidityTooltipErrorSB2",
        humiditySZ1: "humidityTooltipErrorSZ1",
        humiditySZ5: "humidityTooltipErrorSZ5",
        humiditySZ8: "humidityTooltipErrorSZ8",
        humiditySZ11: "humidityTooltipErrorSZ11",
        humidityT1: "humidityTooltipErrorT1",
        humidityT2: "humidityTooltipErrorT2",
        humidityT3: "humidityTooltipErrorT3",
        humidityT4: "humidityTooltipErrorT4",
      },

      // //running -> running tool tip
      // dataNameRunningTooltipNameDict: {
      //   runningDehumidifierNS3: "runningTooltipNS3",
      //   runningDehumidifierNS4: "runningTooltipNS4",
      //   runningDehumidifierNS1: "runningTooltipNS1",
      //   runningDehumidifierNS2: "runningTooltipNS2",
      //   runningDehumidifierNT2: "runningTooltipNT2",
      // },

      //running -> running class
      dataNameRunningClassNameDict: {
        runningDehumidifierNS3: "runningClassNS3",
        runningDehumidifierNS4: "runningClassNS4",
        runningDehumidifierNS1: "runningClassNS1",
        runningDehumidifierNS2: "runningClassNS2",
        runningDehumidifierNT2: "runningClassNT2",
      },
      stationIdList: ["cf933e6f-75c5-45ee-a0a0-41fc00851df9", "17790481-8c80-4615-9a98-b844013ac9e9"],
    };
  },
  filters: {
    toFixed(val) {
      if (val === 0) return "0.0";
      if (!Number(val)) return "--";
      return Number(val).toFixed(1);
    },
  },
  mounted() {
    this.getAllowedMax();
    this.getData();
    this.timer = setInterval(() => {
      this.getData();
    }, this.REFRESH_SECOND);
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  methods: {
    refreshData() {
      this.loading = true;
      this.getData();
    },
    getData() {
      this.resetError();
      let stationRequestList = [];
      this.stationIdList.forEach((stationId) => {
        stationRequestList.push(this.$http.get(`/deviceData/Station?stationId=${stationId}`));
      });

      this.$http.all(stationRequestList).then(
        this.$http.spread((...resList) => {
          resList.forEach((res) => {
            this.setDataAndError(res.data);
            this.loading = false;
          });
        })
      );
    },
    setDataAndError(stationData) {
      for (let dataName in this.dataNameIdDict) {
        const dataId = this.dataNameIdDict[dataName];
        if (stationData[dataId] !== undefined) {
          this[dataName] = stationData[dataId].value;

          // //set value for running sign
          // if (this.dataNameRunningTooltipNameDict[dataName] !== undefined && this.dataNameRunningClassNameDict[dataName] != undefined) {
          //   let runningData = stationData[dataId];
          //   if (runningData.value === 1) {
          //     this[this.dataNameRunningTooltipNameDict[dataName]] = "运行";
          //     this[this.dataNameRunningClassNameDict[dataName]] = "running";
          //   } else if (runningData.errorLevel !== "Warning") {
          //     //empty data value also === 0
          //     this[this.dataNameRunningTooltipNameDict[dataName]] = "停止";
          //     this[this.dataNameRunningClassNameDict[dataName]] = "stopped";
          //   }
          // }

          //set value for running sign
          if (this.dataNameRunningClassNameDict[dataName] != undefined) {
            let runningData = stationData[dataId];
            if (runningData.value === 1) {
              this[this.dataNameRunningClassNameDict[dataName]] = "running";
            } else if (runningData.errorLevel !== "Warning") {
              //empty data value also === 0
              this[this.dataNameRunningClassNameDict[dataName]] = "stopped";
            }
          }

          if (this.dataNameErrorNameDict[dataName] !== undefined) {
            const errorName = this.dataNameErrorNameDict[dataName];
            this[errorName] = this.getErrorLevelFromMultipleDevice(this[errorName], stationData[dataId].errorLevel);
          }

          if (this.dataNameTooltipErrorNameDict[dataName] !== undefined) {
            const errorName = this.dataNameTooltipErrorNameDict[dataName];
            this[errorName] = stationData[dataId].errorLevel;
          }

          if (this.malfunctionDataNameErrorNameDict[dataName] !== undefined) {
            const errorName = this.malfunctionDataNameErrorNameDict[dataName];
            if (this[errorName] === "" && stationData[dataId].value && stationData[dataId].value > 0) {
              this[errorName] = "Error";
            }
          }
        }
      }
    },
    getAllowedMax() {
      let stationMetaRequestList = [];
      this.stationIdList.forEach((stationId) => {
        stationMetaRequestList.push(this.$http.get(`/bridge/StationInfo?stationId=${stationId}`));
      });

      this.$http.all(stationMetaRequestList).then(
        this.$http.spread((...resList) => {
          resList.forEach((res) => {
            this.setAllowedMax(res.data);
          });
        })
      );
    },
    setAllowedMax(stationData) {
      let deviceIdDevicedict = {};
      if (stationData.deviceList) {
        stationData.deviceList.forEach((item) => {
          deviceIdDevicedict[item.deviceId] = item;
        });
      }

      for (let allowedMaxName in this.allowedMaxNameIdDict) {
        const dataId = this.allowedMaxNameIdDict[allowedMaxName];
        if (deviceIdDevicedict[dataId] !== undefined) {
          let device = deviceIdDevicedict[dataId];
          this[allowedMaxName] = device.allowedMax;
        }
      }
    },
    getErrorLevelFromMultipleDevice(newErrorLevel, currentErrorLevel) {
      if (currentErrorLevel === "Error") {
        return "Error";
      } else if (currentErrorLevel === "Warning") {
        if (newErrorLevel === "Error") {
          return "Error";
        } else {
          return "Warning";
        }
      } else {
        return newErrorLevel;
      }
    },
    resetError() {
      for (let dataName in this.dataNameIdDict) {
        if (this.dataNameErrorNameDict[dataName] !== undefined) {
          const errorName = this.dataNameErrorNameDict[dataName];
          this[errorName] = "";
        }

        if (this.dataNameTooltipErrorNameDict[dataName] !== undefined) {
          const errorName = this.dataNameTooltipErrorNameDict[dataName];
          this[errorName] = "";
        }
      }
    },
    assembleTooltip_sensor(name, errorLevel, allowedMax) {
      let result = "";
      if (name) {
        result += name + ": ";
      }

      if (errorLevel.toLowerCase() === "normal") {
        result += "湿度正常";
      } else if (errorLevel.toLowerCase() === "warning") {
        result += "数据中断";
      } else if (errorLevel.toLowerCase() === "error") {
        result += "湿度超限";
      }

      if ((errorLevel.toLowerCase() === "normal" || errorLevel.toLowerCase() === "error") && allowedMax && !isNaN(parseInt(allowedMax))) {
        result += "(<" + allowedMax + "%RH)";
      }

      return result;
    },
    assembleTooltip_dehumidifier(name, errorLevel, allowedMax, runningFlag, errorFlag) {
      let result = "";
      if (name) {
        result += name + ": ";
      }

      if (errorLevel.toLowerCase() === "normal") {
        result += "湿度正常";
      } else if (errorLevel.toLowerCase() === "warning") {
        result += "数据中断";
      } else if (errorLevel.toLowerCase() === "error") {
        result += "湿度超限";
      }

      if ((errorLevel.toLowerCase() === "normal" || errorLevel.toLowerCase() === "error") && allowedMax && !isNaN(parseInt(allowedMax))) {
        result += "(<" + allowedMax + "%RH)";
      }

      if (runningFlag > 0) {
        result += ", 除湿机运行";
      } else if(runningFlag === 0) {
        result += ", 除湿机停止";
      }

      if (errorFlag > 0) {
        result += ", 故障报警";
      }

      return result;
    },
  },
};
</script>

<style lang="scss" scoped>
@keyframes breathee-warning {
  0% {
    border-color: rgba(255, 255, 0, 0.3);
  }
  100% {
    border-color: #ffff00;
    // background: rgba(255, 255, 255, 0.7);
  }
}
@keyframes breathee-error {
  0% {
    border-color: rgba(255, 0, 0, 0.3);
  }
  100% {
    border-color: #ff0000;
    // background: rgba(255, 255, 255, 0.7);
  }
}

.tooltip-slot {
  line-height: 1.4;
}

.gas-clamp {
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  height: calc(100% - 20px) !important;
 // min-height: 630px !important;

  .main-cable {
    width: 100%;
    height: 48%;
    padding: 0;
    display: flex;
    justify-content: flex-start;
    align-items: stretch;
    min-height: 370px;

    .cable-title {
      width: 50px;
      text-align: center;
      display: flex;
      background-color: #fff;
      justify-content: center;
      align-items: center;

      h2 {
        padding: 0 10px;
        font-weight: 400;
        font-size: 24px;
        line-height: 35px;
        color: #515151;
      }
    }

    .cable-main {
      position: relative;
      min-width: 1200px;
      width: calc(100% - 50px);
      background: linear-gradient(#ceeaf0, #e9f1ef);
      display: flex;
      justify-content: center;
      align-items: center;

      .legend {
        position: absolute;
        left: 75px;
        top: 50px;
        div {
          padding-left: 30px;
          height: 20px;
          margin-bottom: 10px;
          line-height: 20px;
          font-size: 14px;
          color: #515151;
          position: relative;
          &:after {
            position: absolute;
            left: 0;
            top: 0;
            content: " ";
            overflow: hidden;
            display: block;
            height: 20px;
            width: 20px;
            border-radius: 10px;
          }
        }
        .sensor1:after {
          background: #c7798b;
        }
        .sensor2:after {
          background: #3376c7;
        }
      }
      .legend-right {
        position: absolute;
        right: 70px;
        top: 50px;
        div {
          padding-left: 30px;
          height: 20px;
          margin-bottom: 10px;
          line-height: 20px;
          font-size: 14px;
          color: #515151;
          position: relative;
          &:after {
            position: absolute;
            left: 0;
            top: 0;
            content: " ";
            overflow: hidden;
            display: block;
            height: 20px;
            width: 20px;
            border-radius: 10px;
          }
        }
        .default:after {
          background: #ffff00;
        }
        .running:after {
          background: #67dd34;
        }
        .stopped:after {
          background: #a0a0a0;
        }
      }
      .legend-station {
        position: absolute;
        left: 73px;
        top: 78px;

        i {
          font-size: 24px;
          color: #ed6a5a;
        }
        span {
          padding-left: 8px;
          bottom: 3px;
          margin-bottom: 10px;
          line-height: 20px;
          font-size: 14px;
          color: #515151;
          position: relative;
        }
      }

      .dir {
        position: absolute;
        top: 50px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        color: #2a387a;
        i {
          font-size: 30px;
        }
        .dir-text {
          font-size: 20px;
        }
      }
      .left-dir {
        left: 250px;
      }
      .right-dir {
        flex-direction: row-reverse;
        right: 250px;
      }
      .cable-img {
        position: relative;
        z-index: 0;
        width: 1200px;
        height: 300px;
        background-position: 50%;
        background-repeat: no-repeat;
        background-size: contain;
        background-image: url("../../assets/image/hangzhouwan/bridgeLine_north.png");
        background-position-y: 100%;

        .station-block {
          position: absolute;
          color: #ed6a5a;
          font-size: 24px;
          text-decoration: none;
        }

        .station-block-left {
          top: 255px;
          left: 335px;
        }

        .station-block-right {
          top: 255px;
          left: 843px;
        }

        .station-block-tower {
          top: 230px;
          left: 586px;
        }

        .stati {
          position: absolute;
          &:before,
          &:after {
            position: absolute;
            display: block;
            content: "";
            height: 2px;
            background: #ed6a5a;
          }
          &:before {
            width: 50px;
          }
          &:after {
            width: 15px;
          }
          .state-info {
            font-size: 14px;
            line-height: 17px;
            color: #515151;
            text-align: right;
            min-width: 75px;
            transform: translateY(-50%);
            position: absolute;
            text-decoration: none;
            border-radius: 10px;
            box-sizing: border-box;
            padding: 6px 8px 6px 6px;
            border: 2px solid transparent;
            box-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
            background-color: rgba(246, 250, 255, 0.9);
            &:before {
              background-color: #ed6a5a;
            }
            & > p {
              margin: 0;
              white-space: nowrap;
              white-space: nowrap;
              display: flex;
              justify-content: space-between;
              align-items: baseline;
              &:first-child {
                font-size: 13px;
              }
            }
            &.right-pos:before {
              right: 0;
              transform: translate(50%, -50%);
            }
            &.left-pos:before {
              left: -8px;
              transform: translate(50%, -50%);
            }
            &:before {
              position: absolute;
              display: block;
              content: "";
              height: 8px;
              width: 8px;
              border-radius: 4px;
              top: 50%;
            }

            .valve-sign {
              margin-top: auto;
              margin-bottom: auto;
              width: 12px;
              height: 12px;
              background-color: #ffff00;
              animation: breathee-valve-sign-default 1500ms infinite alternate ease-in-out;
              border-radius: 10px;
              margin-left: 12px;

              &.running {
                background-color: #67dd34;
                animation: none;
              }
              &.stopped {
                background-color: #a0a0a0;
                animation: none;
              }
            }
          }
          .Warning {
            border-color: #ffff00;
            animation: breathee-warning 1500ms infinite alternate ease-in-out;
          }
          .Error {
            border-color: #ff0000;
            animation: breathee-error 1500ms infinite alternate ease-in-out;
          }
        }

        .sta-left-left {
          top: 262px;
          left: 303px;
          &::before {
            bottom: -25px;
            left: 5px;
            width: 50px;
            transform: rotate(-45deg);
          }
          &::after {
            bottom: -43px;
            left: -2px;
          }
          .state-info {
            right: 2px;
            top: 42px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 130px;
          }
        }

        .sta-left-right {
          top: 262px;
          left: 303px;
          &::before {
            bottom: -25px;
            left: 33px;
            width: 50px;
            transform: rotate(225deg);
          }
          &::after {
            bottom: -43px;
            left: 75px;
          }
          .state-info {
            right: -220px;
            top: 42px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 130px;
          }
        }

        .sta-right-left {
          top: 262px;
          left: 811px;
          &::before {
            bottom: -25px;
            left: 5px;
            width: 50px;
            transform: rotate(-45deg);
          }
          &::after {
            bottom: -43px;
            left: -2px;
          }
          .state-info {
            right: 2px;
            top: 42px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 130px;
          }
        }

        .sta-right-right {
          top: 262px;
          left: 811px;
          &::before {
            bottom: -25px;
            left: 33px;
            width: 50px;
            transform: rotate(225deg);
          }
          &::after {
            bottom: -43px;
            left: 75px;
          }
          .state-info {
            right: -220px;
            top: 42px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 130px;
          }
        }

        .sta-tower {
          top: 230px;
          left: 590px;
          &::before {
            bottom: 7px;
            left: -33px;
            width: 50px;
            transform: rotate(45deg);
          }
          &::after {
            bottom: 24px;
            left: -40px;
          }
          .state-info {
            right: 40px;
            top: -24px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 130px;
          }
        }

        .clip {
          position: absolute;
          width: 16px;
          height: 16px;
          border-radius: 8px;
          &:before,
          &:after {
            position: absolute;
            display: block;
            content: "";
            height: 2px;
          }
          &:before {
            width: 50px;
          }
          &:after {
            width: 15px;
          }
          .state-info {
            font-size: 14px;
            line-height: 17px;
            color: #515151;
            text-align: right;
            min-width: 75px;
            transform: translateY(-50%);
            position: absolute;
            border-radius: 10px;
            box-sizing: border-box;
            padding: 6px 8px 6px 6px;
            border: 2px solid transparent;
            box-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
            & > p {
              margin: 0;
              white-space: nowrap;
              &:first-child {
                font-size: 13px;
              }
            }
            &.right-pos:before {
              right: 0;
              transform: translate(50%, -50%);
            }
            &.left-pos:before {
              left: -8px;
              transform: translate(50%, -50%);
            }
            &:before {
              position: absolute;
              display: block;
              content: "";
              height: 8px;
              width: 8px;
              border-radius: 4px;
              top: 50%;
            }
          }
          .Warning {
            border-color: #ffff00;
            animation: breathee-warning 1500ms infinite alternate ease-in-out;
          }
          .Error {
            border-color: #ff0000;
            animation: breathee-error 1500ms infinite alternate ease-in-out;
          }
          &.sensor1 {
            background: #c7798b;
            &:after,
            &:before {
              background: #c7798b;
            }
            .state-info {
              background-color: rgba(246, 250, 255, 0.9);
              &:before {
                background-color: #c7798b;
              }
            }
          }
          &.sensor2 {
            background: #3376c7;
            &:after,
            &:before {
              background: #3376c7;
            }
            .state-info {
              background-color: rgba(246, 250, 255, 0.9);
              &:before {
                background-color: #3376c7;
              }
            }
          }
        }
        .sensor-s04 {
          top: 260px;
          left: 1085px;
          &::before {
            bottom: 30px;
            left: -2px;
            width: 70px;
            transform: rotate(140deg);
          }
          &::after {
            bottom: 52px;
            left: 58px;
          }
          .state-info {
            right: -169px;
            top: -37px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 110px;
          }
        }

        .sensor-sb12 {
          top: 260px;
          left: 1020px;
          &::before {
            bottom: 60px;
            left: -23px;
            width: 120px;
            transform: rotate(120deg);
          }
          &::after {
            bottom: 112px;
            left: 66px;
          }
          .state-info {
            right: -179px;
            top: -97px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 110px;
          }
        }

        .sensor-sb8 {
          top: 260px;
          left: 883px;
          &::before {
            bottom: 89px;
            left: -40px;
            width: 190px;
            transform: rotate(120deg);
          }
          &::after {
            bottom: 170px;
            left: 101px;
          }
          .state-info {
            right: -212px;
            top: -155px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 110px;
          }
        }

        .sensor-sb5 {
          top: 260px;
          left: 780px;
          &::before {
            bottom: 105px;
            left: -62px;
            width: 210px;
            transform: rotate(110deg);
          }
          &::after {
            bottom: 204px;
            left: 78px;
          }
          .state-info {
            right: -188px;
            top: -189px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 110px;
          }
        }

        .sensor-sb2 {
          top: 260px;
          left: 678px;
          &::before {
            bottom: 122px;
            left: -90px;
            width: 235px;
            transform: rotate(100deg);
          }
          &::after {
            bottom: 237px;
            left: 47px;
          }
          .state-info {
            right: -157px;
            top: -222px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 110px;
          }
        }

        .sensor-sz1 {
          top: 260px;
          left: 538px;
          &::before {
            bottom: 120px;
            left: -154px;
            width: 240px;
            transform: rotate(70deg);
          }
          &::after {
            bottom: 233px;
            left: -89px;
          }
          .state-info {
            right: 104px;
            top: -218px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 110px;
          }
        }

        .sensor-sz5 {
          top: 260px;
          left: 402px;
          &::before {
            bottom: 105px;
            left: -133px;
            width: 210px;
            transform: rotate(70deg);
          }
          &::after {
            bottom: 204px;
            left: -78px;
          }
          .state-info {
            right: 94px;
            top: -189px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 110px;
          }
        }

        .sensor-sz8 {
          top: 260px;
          left: 303px;
          &::before {
            bottom: 89px;
            left: -135px;
            width: 190px;
            transform: rotate(60deg);
          }
          &::after {
            bottom: 170px;
            left: -102px;
          }
          .state-info {
            right: 119px;
            top: -155px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 110px;
          }
        }

        .sensor-sz11 {
          top: 260px;
          left: 205px;
          &::before {
            bottom: 60px;
            left: -82px;
            width: 120px;
            transform: rotate(60deg);
          }
          &::after {
            bottom: 112px;
            left: -66px;
          }
          .state-info {
            right: 82px;
            top: -97px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 110px;
          }
        }

        .sensor-t4 {
          top: 30px;
          left: 590px;
          &::before {
            bottom: 22px;
            left: -33px;
            width: 50px;
            transform: rotate(45deg);
          }
          &::after {
            bottom: 39px;
            left: -40px;
          }
          .state-info {
            right: 56px;
            top: -24px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 110px;
          }
        }

        .sensor-t3 {
          top: 80px;
          left: 590px;
          &::before {
            bottom: 22px;
            left: 0px;
            width: 50px;
            transform: rotate(135deg);
          }
          &::after {
            bottom: 39px;
            left: 42px;
          }
          .state-info {
            right: -152px;
            top: -24px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 110px;
          }
        }

        .sensor-t2 {
          top: 130px;
          left: 590px;
          &::before {
            bottom: 22px;
            left: -33px;
            width: 50px;
            transform: rotate(45deg);
          }
          &::after {
            bottom: 39px;
            left: -40px;
          }
          .state-info {
            right: 56px;
            top: -24px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 110px;
          }
        }

        .sensor-t1 {
          top: 180px;
          left: 590px;
          &::before {
            bottom: 22px;
            left: 0px;
            width: 50px;
            transform: rotate(135deg);
          }
          &::after {
            bottom: 39px;
            left: 42px;
          }
          .state-info {
            right: -152px;
            top: -24px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 110px;
          }
        }
      }
    }
  }
}
</style>